export const imagePreviewArray = state => state.modals.imagePreviewArray;
export const imagePreviewIndex = state => state.modals.imagePreviewIndex;
export const imagePreviewShow = state => state.modals.imagePreviewShow;
export const imagePreviewStepId = state => state.modals.imagePreviewStepId;